

































import Vue from "vue";
import Component from 'vue-class-component';
import StarIcon from 'vue-material-design-icons/Star.vue';

@Component({
    components: { StarIcon },
})
export default class DetalhesGuincho extends Vue {
    public image = require("@/assets/images/tow-truck.svg");
    public readonly terceiros = [
        { label: "Sim", value: 14.9, index: 0 },
        { label: "Não", value: 0,    index: 1 },
    ];

    get cobertura () {
        return this.$store.state.cotacao.valor_guincho;
    }

    set cobertura (value) {
        this.$store.commit('SET_GUINCHO', value);
    }
}
